import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M8.571 12h6.858m2.285 8H6.286A2.286 2.286 0 0 1 4 17.714V6.286A2.286 2.286 0 0 1 6.286 4h11.428C18.476 4 20 4.457 20 6.286v11.428A2.286 2.286 0 0 1 17.714 20z",
      stroke: "#16699C",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ]))
}